<div id="csv-view-div" style="display: block">
  <div id="CSV_multilayer">
    <div class="chose-layers-div" *ngIf="allLayersTypeName.length > 1">
      <p id="dataset">
        <span class="multi-layer-steps">1</span
        ><b>Choose layers for which to download a CSV:</b>
      </p>
      <ng-container *ngFor="let name of allLayersTypeName">
        <span style="display: inline"
          ><div class="csv_layers">
            <input
              (change)="onChange($event)"
              type="checkbox"
              class="csv_view_checks"
              name="csv_multilayer"
              [value]="name"
              style="position: absolute; left: 39px; margin-right: 5px"
            />
            <p id="csv_layers_names">{{ name }}</p>
          </div></span
        >
      </ng-container>
    </div>
    
  </div>
  <span style="display: inline; margin-left: 13px" id="download-csv"
      ><input
        type="button"
        id="csv_download"
        value="Download"
        (click)="download()" /></span
    ><span
      *ngIf="showMsg"
      class="err-select-layers glyphicon glyphicon-warning-sign"
      style="margin-left: 5px; font-style: normal"
    ></span
    ><span
      class="err-select-layers"
      *ngIf="showMsg"
    >
      To download, select one or more layers above</span
    >
  <hr id="separater-line" />
  <div class="data-view-desc">
    <p>CSV files will include all data from your selected features.</p>
    <p>
      Once downloaded, they can be opened as a spreadsheet in commonly used
      software programs such as Microsoft Excel or Google Sheets.
    </p>
    <p>
      If you have selected multiple layers to download, each will generate a
      separate CSV file and will be downloaded automatically, appearing in your
      downloads folder.
    </p>
  </div>
</div>
<app-loader></app-loader>